import { Component, OnInit } from '@angular/core';
import { SupportService } from 'src/app/services/core/support/support.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { TripService } from 'src/app/services/core/trip/trip.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import * as moment from 'moment-timezone';
import { MenuService } from '../../shared/layout/menu-service/menu.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { timeZone } from 'src/app/utils/utils.common';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { sweetAlert } from 'src/app/utils/swal';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { UserPermission } from 'src/app/enums/enums';
import { CsvService } from 'src/app/services/core/csv-service/csv.service';
@UntilDestroy()
@Component({
  selector: 'app-trip-list',
  templateUrl: './trip-list.component.html',
  styleUrls: ['./trip-list.component.css']
})
export class TripListComponent implements OnInit {
  user: any;
  subMenus:any;
  selectedStatus: any
  todayDate: any;
  search:any;
  selectedDropdownIndex:any;
  toggleActionButtons = false;
  singleTrip:any
  selectedTrips:any = [];
  tripId:any;
  levelofservices:any;
  isDistributionModal = false;
  preServiceAreas:any;
  preLevelOfService: any = {};
  trips:any = [];
  isMultiCancelModal = false;
  memberNotesObj:any;
  isAutoDistributionModal:any;
  selectedServiceArea:any = ''
  userPermission=UserPermission;
  spacetypes:any;
  filterdataList:any = [];
  selectedSpaceType:any = ''
  preSpacetypes:any = {};
  // preMembers:any = {};
  preAppointmentType:any = {};
  selectedCompany = '';
  source:any ='';

  // Pagination
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  serviceAreas:any
  numberOfRecords = NUMBER_OF_RECORDS;
  timeZone = timeZone;
  trailsTripId:any;
  cancelTripObj:any;
  isDropdownOpen = false;
  signatureModalObj: any;


  constructor(
    private supportService: SupportService,
    private appointmentService : AppointmentTypeService,
    private memberService : MemberService,
    private SpaceTypeService : SpaceTypeService,
    private credentialService: CredentialService,
    private LosService: LosService,
    private tripService : TripService,
    private sharedDataService: SharedDataService,
    private menuService: MenuService,
    private serviceAreasService: ServiceAreasService,
    private router: Router,
    public permissionService: PermissionService,
    private csvService: CsvService,
    private route: ActivatedRoute
  ) { }
  ngOnInit(): void {
    this.subMenus = this.menuService.getTripsSubMenus();
    this.selectedStatus = this.subMenus && this.subMenus.length ? this.subMenus[0].value : '';
     this.setupFragment();
    this.getAppointmentTypes();
    // this.getAllMembers();
    this.getSpaceType();
    this.getUser();
  }

  setupFragment() {
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      this.selectedStatus = fragment
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        fragment: this.selectedStatus
      });
    }
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (!fragment) {
          // case: trips menu is already activated and it is clicked again in the sidenav
          this.onSelectMenu("offered");
        } else {
          // case: click on the trip notification in notification modal
          if (this.selectedStatus !== fragment) {
            this.onSelectMenu(fragment);
          }
        }
      });
    }, 1000);
  }
  

  getUser() {
    this.sharedDataService
    .getUser().pipe(untilDestroyed(this))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.timeZone = this.user.timeZone; 
        this.todayDate = [
          moment().tz(this.timeZone).startOf('day'),
          moment().tz(this.timeZone).endOf('day')
        ];
        this.getAllTrips(this.currentPage);
      }
    });
    this.getServiceAreas();
    this.getLevelOfService()
  }
  
  getAppointmentTypes(){
    const queryparams = {
      isActive: true, 
      limit:9999
    }
    this.appointmentService.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data.results ){
        this.preAppointmentType = data.results.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
      }
    })
  }

   opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

   raiseTicket(trip: any) {
     this.supportService.raiseTicket('trip', trip.id);
   }

    cancelSignleTrip(trip: any) {
    this.source = 'cancel'
    this.singleTrip = [trip];
    this.isMultiCancelModal = true;
  }
    reRouteTrip(trip: any) {
    this.source = 'reroute'
    this.singleTrip = [trip];
    this.isMultiCancelModal = true;
  }

   editTrip(evt:any){
    this.router.navigateByUrl(`trips/${evt.id}/edit`)
  }

   openAdjustTrip(event:any){
    this.router.navigateByUrl(`trips/${event.id}/adjustTrip`);
  }

  getSpaceType() {
    const queryParams = {
      isActive: true, 
      limit:9999
    }
    this.SpaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.preSpacetypes = this.spacetypes.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  // getAllMembers(){
  //   let queryParams = {
  //     limit : 9999,
  //   }
  //   this.memberService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
  //     if (data && data.results ){
  //       this.preMembers =  data.results.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
  //     }
  //   })
  // }

   getAllTrips(page: any) {
    this.clear();
    let queryparams = {
      limit: 50,
      page,
      status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      company: this.selectedCompany || undefined,
      sortBy: 'pickup.time:asc',
      spaceType: this.selectedSpaceType,
      serviceArea: this.selectedServiceArea
    }
     if (!this.selectedSpaceType){
      delete queryparams.spaceType
     }
     if (!this.selectedServiceArea){
       delete queryparams.serviceArea
     }
    if (this.selectedStatus === '') {
      queryparams.status = [
        'scheduled',
        'offered',
        'completed',
        'cancelled',
        'onway',
        'arrived',
        'in_progress',
        'marketplace',
        'reroute'
      ];
    } else {
      queryparams.status = this.selectedStatus;
    }
    if (!this.selectedCompany) {
      delete queryparams.company;
    }
    this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.trips = data.results;
          this.filterdataList = this.trips;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }


   getPageCount() {
    const length = this.filterdataList.length;
    const count = (50 * this.currentPage) - (length !== 50 ? (50 - length) : 0);
    return `${count} of ${this.totalResults}`;
  }

    clear(){
    this.trips = []
    this.selectedTrips = []
    // this.trip.isSelected = false;
  }

  // getTrips(page:any) {
  //   const queryparams = {
  //     limit: 50,
  //     page,
  //     company: this.user && this.user.company ? this.user.company.id : null,
  //     status: this.selectedStatus,
  //     time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()]
  //   }
  //   this.tripService.getAllTrips(queryparams).pipe(untilDestroyed(this)).subscribe((data:any) => {
  //     if (data && data.results) {
  //     //  this.trips = data.results;
  //      this.trips = data.results;
  //      this.totalPages = data.totalPages;
  //      this.totalResults = data.totalResults;
  //     }
  //   })
  // }

  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id); // Check if trip is already selected
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
    }
  }

  onSelectAllTrips(event: any) {
    const checked = event.target.checked;
    this.trips.forEach((trip: any) => trip.isSelected = checked);
    this.selectedTrips = checked ? [...this.trips] : [];
  }

  assignSingleTrip(trip: any) {
    this.singleTrip = [trip];
    this.isDistributionModal = true;
  }

   openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  openDetailModal(trip:any){
    this.tripId = trip.id;
  }

  onDateChange(event:any) {
    if (event && event.length) {
      this.todayDate = [
      event[0],
      event[1].endOf("day"),
      ];
      this.getAllTrips(this.currentPage);
    }
  }

  onSelectMenu(status: any) {
    this.currentPage = 1;
    this.selectedStatus = status;
    this.getAllTrips(this.currentPage);
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: status
    });
  } 
  openDistributionModal(){
    this.isDistributionModal = true
  }

    closeActionMenu(evt:any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

   sendtoMarketPlace(event: any, index: any) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

   backtoSchedule(event: any, index: any,) {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trip to schedule",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const payload = {
          selectedIds: [event.id],
          company: null,
          status: "scheduled"
        };
        this.apiRequest(payload, [event.id]);
      }
    });
  }

    showActionButtons(idx:any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  sendBulktoMarketPlace() {
    sweetAlert(
      "Alert",
      "Are you sure you want to send trips to marketplace",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
        const payload = {
          selectedIds: selectedTripIds,
          company: null,
          status: "marketplace"
        };
        this.apiRequest(payload, selectedTripIds);
      }
    });

  }

   apiRequest(payload: any, selectedTripIds: any) {
    this.tripService.sendtoMarketPlace(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        selectedTripIds.forEach((id: number) => {
          const index = this.trips.findIndex((trip: any) => trip.id === id);
          if (index !== -1) {
            this.trips.splice(index, 1);
          }
          this.closeActionMenu(null);
        });
        this.selectedTrips = [];
      }
    });
  }

    openAutoDistributionModal(event?:any){
    this.isAutoDistributionModal = true
    if(event){
    this.singleTrip = [event];
    }
  }

  getServiceAreas() {
    this.serviceAreasService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.serviceAreas = data.results;
          this.preServiceAreas = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

   getLevelOfService(){
     this.LosService.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.levelofservices = data.results;
          this.preLevelOfService = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  closeMultiCancelModal() {
    this.isMultiCancelModal = false;
    if (this.singleTrip) {
      this.singleTrip = null;
    }
  }

  onCancelTrip(evt: any[]) {
    if (evt.length) {
      this.trips = this.trips.filter(
        (trip: any) => !evt.includes(trip.id)
      );
      this.filterdataList = [...this.trips];
    }
    this.singleTrip = null;
    this.cancelTripObj = null;
    this.selectedTrips = [];
    this.uncheckTrips();
  }

  uncheckTrips() {
    this.trips.forEach((trip: any) => trip.isSelected = false);
  }
  
  closeModal(){
    this.isDistributionModal = false;
  }

   openTripTrails(trip: any) {
    this.trailsTripId = trip.id;
  }

  closeFilterDropDown(evt: any) {
    this.isDropdownOpen = false
  }

  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSpaceTypeChange() {
    this.getAllTrips(this.currentPage);
  }

  getSelectedTrips() {
    return this.trips
      .filter((trip: any) => trip.isSelected);
  }


  getDateRangeWiseTrips() {
    const queryParams: any = {
      limit: 9999,
      status: this.selectedStatus,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    if (this.selectedSpaceType) {
      queryParams.spaceType = this.selectedSpaceType;
    }
    if (this.selectedTrips?.length) {
      this.csvService.generateTripReport(
        this.selectedTrips,
        this.todayDate,
        this.timeZone,
        this.preServiceAreas,
        this.preLevelOfService,
        this.preSpacetypes,
      );
    } else {
      this.tripService.getTripsReport(queryParams)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data && data.results) {
            this.csvService.generateTripReport(data.results, this.todayDate, this.timeZone
            )
          }
        });
    }
  }

  openSignatureModal(trip: any) {
    this.signatureModalObj = trip;
  }

  onCloseSignatureModal(evt: any) {
    if (evt) {
      this.signatureModalObj.signature = evt.signature;
    }
    this.signatureModalObj = null;
  }

  // bulkFundingSourceAdjust() {
  //   const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
  //   const payload: any = {
  //     selectedIds: selectedTripIds,
  //   };
  //   this.tripService.bulkFundingSourceAdjust(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data) {
  //       this.selectedTrips = [];
  //       this.filterdataList.forEach((trip: any) => trip.isSelected = false);
  //       sweetAlert("Alert", "Funding Source Adjustments processed successfully", "success", "OK");
  //     }
  //   });
  // }

  bulkVendorAdjust() {
    const selectedTripIds = this.selectedTrips.map((trip: any) => trip.id);
    const payload: any = {
      selectedIds: selectedTripIds,
    };
    this.tripService.bulkVendorAdjust(payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.selectedTrips = [];
        this.filterdataList.forEach((trip: any) => trip.isSelected = false);
        sweetAlert("Alert", `Vendor Adjustments processed successfully${data.batchId ? ` (Batch ${data.batchId})` : ''}`, "success", "OK");

      }
    });
  }
 
}
